module.exports = __webpack_public_path__ + "static/signup-forms-35a76092bb4778e8111ad7c8da0afdc4.svg";